import { ColDef, themeAlpine } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import startCase from "lodash.startcase";
import { DateTime } from "luxon";
import { useMemo } from "react";

import { IgTableWrapper } from "@intelligems/ig-theme";
import { OrganizationMeterLogDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { DecimalFormat } from "@src/features/admin/components/utils";
import { theme } from "@src/theme";

interface StripeEventMeterLogTableProps {
  events: OrganizationMeterLogDto[];
}

const myTheme = themeAlpine.withParams({
  fontFamily: theme.typography.fontFamily,
});

export const StripeEventMeterLogTable = ({
  events,
}: StripeEventMeterLogTableProps) => {
  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1,
    };
  }, []);

  const columnDefs: ColDef<OrganizationMeterLogDto>[] = useMemo(
    () => [
      {
        headerName: "Created At",
        field: "createdAtTs",
        valueGetter: (params) => {
          return DateTime.fromMillis(
            params.data?.createdAtTs || 0
          ).toLocaleString(DateTime.DATETIME_SHORT);
        },
      },
      {
        headerName: "Meter",
        field: "meteredBillingMethod",
        valueGetter: (params) => {
          return startCase(params.data?.meteredBillingMethod || "");
        },
      },
      {
        headerName: "Amount",
        field: "meteredBillingAmount",
        valueFormatter: (params) => {
          return DecimalFormat.format(params.value);
        },
      },
    ],
    []
  );

  return (
    <Grid
      item
      sx={{
        width: "100%",
        "& .ag-center-cols-clipper": {
          minHeight: "100px !important",
        },
      }}
    >
      <IgTableWrapper minHeight={"100px"} height={null}>
        <AgGridReact<OrganizationMeterLogDto>
          theme={myTheme}
          rowData={events}
          domLayout={"autoHeight"}
          defaultColDef={defaultColDef}
          columnDefs={columnDefs}
          headerHeight={25}
          suppressCellFocus={true}
        />
      </IgTableWrapper>
    </Grid>
  );
};
